// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2-vR2","tableTitle":"styles_tableTitle__14WBp","tableRowsEmpty":"styles_tableRowsEmpty__2UvKW"};